import { useMemo } from 'react';
import useVariants from 'personalization-lib/hooks/variants/useVariants';
import { getVariantName } from 'personalization-lib/utils/variantSelect';
const useVariantSelectOptions = ({
  value,
  strategyId,
  onError
}) => {
  const {
    variants,
    loading,
    error
  } = useVariants(strategyId, onError);
  const valueNotFound = useMemo(() => {
    var _variants$find;
    return Boolean(value) && !((_variants$find = variants.find(v => v.assetCoordinates.id === value)) !== null && _variants$find !== void 0 && _variants$find.assetData);
  }, [variants, value]);
  const options = useMemo(() => variants.filter(variant => variant.assetData).map(variant => Object.assign({
    value: variant.assetCoordinates.id,
    text: getVariantName(variant.assetData),
    loading,
    error
  }, variant)), [variants, loading, error]);
  return useMemo(() => ({
    options,
    loading,
    error,
    valueNotFound
  }), [options, loading, error, valueNotFound]);
};
export default useVariantSelectOptions;